import React from 'react';
import { toast } from 'react-toastify';
import { Notification } from 'shared/components/Notification';
import { DEFAULT_ERROR_MESSAGE } from 'constants/toastyMessages';
import { formatErrorMessage } from 'shared/utils';
import { UseNotificationOptions } from '../types';
import { defaultToastConfig } from '../configs';

export const showNotification = ({
  message = DEFAULT_ERROR_MESSAGE,
  errorObject,
  toastConfig = {},
  type = 'error',
}: UseNotificationOptions | undefined = {}): void => {
  const getMessage = () => {
    if (errorObject) {
      return formatErrorMessage(errorObject);
    }

    return message;
  };

  if (type === 'success') {
    toast.success(<Notification type={type} message={getMessage()} />, {
      ...defaultToastConfig,
      ...toastConfig,
    });
  }

  if (type === 'error') {
    toast.error(<Notification type={type} message={getMessage()} />, {
      ...defaultToastConfig,
      ...toastConfig,
    });
  }

  if (type === 'info') {
    toast.error(<Notification type={type} message={getMessage()} />, {
      ...defaultToastConfig,
      ...toastConfig,
    });
  }
};
